import React from 'react';
import { bindActionCreators } from 'redux';
import { Route, withRouter } from 'react-router';
import { connect } from 'react-redux';
import Layout from './components/Layout';
import Course from './containers/Course';
import Courses from './containers/Courses';
import Dashboard from './containers/Dashboard';
import Login from './components/login/login';
import Contacts from './containers/Contacts';
import ContactList from './containers/ContactList';
import Reports from './containers/Reports';
import Program from './containers/Program';
import Programs from './containers/Programs';
import Grant from './containers/Grant';
import Grants from './containers/Grants';
import Person from './containers/Person';
import Project from './containers/Project';
import Projects from './containers/Projects';
import Report from './components/reporting/report';
import Jurisdictions from './containers/Jurisdictions';
import Jurisdiction from './containers/Jurisdiction';
import NewUser from './containers/NewUser';
import Sessions from './containers/Sessions';
import Session from './containers/Session';
import Training from './containers/Training';
import Trainings from './containers/Trainings';
import TrainingTypes from './containers/TrainingTypes';
import TrainingType from './containers/TrainingType';
import Users from './containers/Users';
import SecureRoute from './utils/secureRoute';
import * as loginActions from './actions/login';
import * as contextActions from './actions/Context';
import * as staticActions from './actions/StaticData';
import * as trainingsActions from './actions/Trainings';
import * as programsActions from './actions/Programs'
import * as trainingActions from './actions/Training';
import * as trainingTypesActions from './actions/TrainingTypes';
import { getJurisdiction } from './actions/Jurisdictions';
import { newJurisdiction } from './actions/Jurisdiction';
import { getSessions } from './actions/Sessions';
import { newSession } from './actions/Session';
import { dismissAlert } from './actions/Alert';
import { getUser } from './actions/User';
import { ThreeDots as Loader } from 'react-loader-spinner';
import './app.css';
import { AdminMenu } from './components/AdminMenu';
import rg4js from 'raygun4js'; // Import the library with this syntax

class App extends React.Component {

    getSpinnerStyle = () => {
        return this.props.isLoading ? null : { display: 'none' };
    }

    componentDidMount() {
        rg4js('apiKey', 'vWD4XxTSjxx2oErrZnug');
        rg4js('enableCrashReporting', true);
        rg4js('enablePulse', true);
    }

    componentDidUpdate(prevProps) {
        if (this.props.isAuthenticated !== prevProps.isAuthenticated && this.props.isAuthenticated) {
            this.props.actions.getAppVersion();
            this.props.actions.getAddressTypes();
            this.props.actions.getClaims();
            this.props.actions.getCourtTypes();
            this.props.actions.getCommitteeAssignments();
            this.props.actions.getDisciplines();
            this.props.actions.getGenerations();
            this.props.actions.getGrantTypes();
            this.props.actions.getPersonDocumentTypes();
            this.props.actions.getTrainingLocationTypes();
            this.props.actions.getPersonnelTypes();
            this.props.actions.getPersonTypes();
            this.props.actions.getPhoneTypes();
            this.props.actions.getProperTitles();
            this.props.actions.getRoles();
            this.props.actions.getSessions();
            this.props.actions.getStates();
            this.props.actions.getTrainingDocumentTypes();
            this.props.actions.getTimeZones();
            this.props.actions.getProgramPickList();
            this.props.actions.getTrainingTypesPickList();
            this.props.actions.getJournalTypes();
            this.props.actions.getJournalStatusTypes();
        }
    }

    render() {

        return (
            <div className='app'>
                <div className='loaderFade' style={this.getSpinnerStyle()}>
                    <Loader
                        type="Puff"
                        color="#00BFFF"
                        height={100}
                        width={100}
                    />
                </div>

                <Layout {...this.props}>
                    <Route exact path='/' render={(props) => <Login {...props} {...this.props} />} />
                    <SecureRoute exact path='/home' component={Dashboard} {...this.props} />
                    <SecureRoute exact path='/courses/course' component={Course} {...this.props} />
                    <SecureRoute exact path='/courses/course/:id' component={Course} {...this.props} />
                    <SecureRoute exact path='/courses/course/:courseId/section/:id' component={Course} {...this.props} />
                    <SecureRoute exact path='/sections/section/:id' component={Course} {...this.props} />
                    <SecureRoute exact path='/sections/section' component={Course} {...this.props} />
                    <SecureRoute exact path='/sections/section/:sectionId/learneroutcome/:id' component={Course} {...this.props} />
                    <SecureRoute exact path='/sections/section/:sectionId/learneroutcome' component={Course} {...this.props} />
                    <SecureRoute exact path='/courses/course/:courseId/section' component={Course} {...this.props} />
                    <SecureRoute exact path='/courses/course/:courseId/section/:sectionId/learneroutcome/:id' component={Course} {...this.props} />
                    <SecureRoute exact path='/courses/course/:courseId/section/:sectionId/learneroutcome' component={Course} {...this.props} />
                    <SecureRoute exact path='/courses' component={Courses} {...this.props} />
                    <SecureRoute exact path='/contacts' component={Contacts} {...this.props} />
                    <SecureRoute exact path='/contactlist' component={ContactList} {...this.props} />
                    <SecureRoute exact path='/users' component={Users} {...this.props} />
                    <SecureRoute exact path='/users/user' component={NewUser} {...this.props} />
                    <SecureRoute exact path='/users/user/:id' component={Person} {...this.props} />
                    <SecureRoute exact path='/persons/person/:id' component={Person} {...this.props} />
                    <SecureRoute exact path='/persons/new' component={Person} {...this.props} />
                    <SecureRoute exact path='/programs' component={Programs} {...this.props} />
                    <SecureRoute exact path='/programs/program' component={Program} {...this.props} />
                    <SecureRoute exact path='/programs/program/:id' component={Program} {...this.props} />
                    <SecureRoute exact path='/grants/grant' component={Grant} {...this.props} />
                    <SecureRoute exact path='/grants/grant/:id' component={Grant} {...this.props} />
                    <SecureRoute exact path='/grants' component={Grants} {...this.props} />
                    <SecureRoute exact path='/projects' component={Projects} {...this.props} />
                    <SecureRoute exact path='/projects/project' component={Project} {...this.props} />
                    <SecureRoute exact path='/projects/project/:id' component={Project} {...this.props} />
                    <SecureRoute exact path='/admin' component={AdminMenu} {...this.props} />
                    <SecureRoute exact path='/reports' component={Reports} {...this.props} />
                    <SecureRoute exact path='/sessions' component={Sessions} {...this.props} />
                    <SecureRoute exact path='/sessions/session' component={Session} {...this.props} />
                    <SecureRoute exact path='/sessions/session/:id' component={Session} {...this.props} />
                    <SecureRoute exact path='/jurisdictions' component={Jurisdictions} {...this.props} />
                    <SecureRoute exact path='/jurisdictions/jurisdiction' component={Jurisdiction} {...this.props} />
                    <SecureRoute exact path='/jurisdictions/jurisdiction/:id' component={Jurisdiction} {...this.props} />
                    <SecureRoute exact path='/sections' component={Courses} {...this.props} />
                    <SecureRoute exact path='/trainings' component={Trainings} {...this.props} />
                    <SecureRoute exact path='/trainings/training/:id' component={Training} {...this.props} />
                    <SecureRoute exact path='/trainings/training' component={Training} {...this.props} />
                    <SecureRoute exact path='/trainingTypes' component={TrainingTypes} {...this.props} />
                    <SecureRoute exact path='/trainingTypes/trainingType' component={TrainingType} {...this.props} />
                    <SecureRoute exact path='/trainingTypes/trainingType/:id' component={TrainingType} {...this.props} />
                    <SecureRoute exact path='/reporting/demo' component={Report} {...this.props} />
                </Layout>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const claims = state.login.getIn(['context', 'user', 'claims']);

    return {
        alerts: state.Alerts,
        appVersion: state.StaticData.get('appVersion'),
        context: state.login.get('context'),
        currentSessionId: claims && parseInt(claims.find(x => x.get('claimType') === 'ACT.CurrentSession').get('claimValue'), 10),
        isAuthenticated: state.login.get('isAuthenticated', false),
        isAdmin: state.login.getIn(['context', 'user', 'isAdmin']),
        isLoading: state.loader.get('isLoading', false),
        loginMessage: state.login.get('message'),
        sessions: state.Sessions,

        //Static data:
        journalTypes: state.StaticData.get('journalTypes').toJS(),
        addressTypes: state.StaticData.get('addressTypes').toJS(),
        claims: state.StaticData.get('claims').toJS(),
        courtTypes: state.StaticData.get('courtTypes').toJS(),
        committeeAssignments: state.StaticData.get('committeeAssignments').toJS(),
        disciplines: state.StaticData.get('disciplines').toJS(),
        generations: state.StaticData.get('generations').toJS(),
        grantTypes: state.StaticData.get('grantTypes').toJS(),
        personDocumentTypes: state.StaticData.get('personDocumentTypes').toJS(),
        personnelTypes: state.StaticData.get('personnelTypes').toJS(),
        personTypes: state.StaticData.get('personTypes').toJS(),
        phoneTypes: state.StaticData.get('phoneTypes').toJS(),
        trainingLocationTypes: state.StaticData.get('trainingLocationTypes').toJS(),
        properTitles: state.StaticData.get('properTitles').toJS(),
        roles: state.StaticData.get('roles').toJS(),
        states: state.StaticData.get('states').toJS(),
        trainingDocumentTypes: state.StaticData.get('trainingDocumentTypes').toJS()
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...loginActions,
            ...contextActions,
            ...staticActions,
            ...trainingActions,
            ...trainingsActions,
            ...programsActions,
            ...trainingTypesActions,
            getUser,
            getSessions,
            getJurisdiction,
            newSession,
            newJurisdiction,
            dismissAlert
        }, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
